export default "__VITE_ASSET__D1K5y09J__"